<a
  [routerLink]="['collection',collectionNo]"
  aria-label="Shop All Best Sellers"
>
  <h2>New Arrivals</h2>
</a>
<a
  class="all"
  [routerLink]="['collection',collectionNo]"
  aria-label="Shop All Best Sellers"
  >Shop All New Arrivals</a
>

@if (loading) {
<div class="loading">
  <mat-spinner [diameter]="40"></mat-spinner>
</div>
}@else {
<div class="products">
  <app-product-list-item [data]="products[0]"></app-product-list-item>
  <swiper-container
    autoplay="true"
    autoplay-delay="4000"
    slides-per-view="auto"
    space-between="10"
    slides-offset-before="10"
    slides-offset-after="10"
    loop="false"
    #swiper
  >
    @for (product of products; track $index) {
    <swiper-slide
      appSlideup
      [slideUpDelay]="$index*50"
      [slideUpMaxDelay]="250"
      [onIntersection]="true"
      lazy="false"
    >
      <app-product-list-item [data]="product"></app-product-list-item>
    </swiper-slide>
    }
  </swiper-container>
</div>

}
